import { Box, Button, Grid, Typography } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import React, { useEffect } from 'react'
import { Dispatch, Spinner } from 'shared'
import { TableComponent } from 'shared/components/Table.component'
import { Layout } from 'shared/utils/ui/Layout'
import styles from './styles/userManagement.module.scss'
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth'
import { useUserManagement } from './hook/useUserManagement'
import { GroupAdd } from '@mui/icons-material';
import { useInfoUser } from 'shared/hooks/useInfoUser';
import { useDispatch } from 'react-redux';

export const UserManagement = () => {

    const { user } = useInfoUser();
    const { 
        handleChange,
        handleSubmit,
        columns,
        valuesResultsPages,
        loading,
        showForm,
        dataFields,
        getValue,
        toogleShowForm,
        createUser,
        getDataToken,
        getDataUsers,
        isLoading 
      } = useUserManagement(user);
      const dispatch = useDispatch<Dispatch>();
      const { width } = useWidth();

      useEffect(() => {
        dispatch.electronicDocuments.cleanState();
        getDataToken();
      }, [])

  return (
    <Layout>
        <Box display={'flex'} justifyContent={'space-between'} marginTop={'.3rem'}>
                  <Typography className='titleMainLayout'>Gestion de Usuarios Prestadores</Typography>
                  <Box display={'flex'} gap={1}>
                    <Button 
                      className={styles.buttonsActions}
                      onClick={() => createUser()}
                      endIcon={<GroupAdd/>}
                      variant='contained' 
                      data-testid='update-excel'
                    >
                      Crear usuario
                    </Button>
                    <Button 
                      className={styles.buttonsActions}
                      onClick={toogleShowForm}
                      endIcon={showForm ? <FilterAltOffIcon/> : <FilterAltIcon/>}
                      variant='contained' 
                      data-testid='btn-filters-contracts'
                    >
                      Filtrar
                    </Button>
        
                  </Box>
                </Box>
                {
                  showForm && (
                    <form className={`${styles.formReadDocuments} form-documents`} noValidate onSubmit={handleSubmit} data-testid='form-read-documents'>
                        <Grid container direction={"row"} className={styles.containerReadDocuments}>
                        {
                            dataFields.map((field,i)=> (
                                <Grid item xs={12} md={6} lg={4} className={ styles.containerGridItem } key={i}>
                                    <label htmlFor={field.id}>
                                        {field.label}
                                    </label>
                                    <input 
                                        type='text'
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        id={field.id}
                                        data-testid={field.testId}
                                        value={ getValue(field.name) }
                                        onChange={handleChange}
                                    />
                                </Grid>
                                
                            ))
                        }
                            <Grid container direction={"row"} justifyContent={'center'}>
                                <Button type='submit' variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn-submit">
                                    Consultar
                                </Button>
                                <Button variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn-submit" onClick={getDataUsers}>
                                    Limpiar
                                </Button>
                            </Grid>
                        </Grid>

                    </form>
                  )
                }
                <Box paddingTop={'.5rem'} height={showForm ? '72%' : '89%'}>
                  <TableComponent 
                    columns={columns}
                    title=''
                    valuesResultsPages={valuesResultsPages}
                    classTotalElemnt={width < 500 ? '' : 'classTotalElemnt'}
                    showBtnCollapse={false}
                    hiddenHeaderSearch={true}
                    isSearch={false}
                  />
                </Box>
                {( loading || isLoading ) && <Spinner />}

    </Layout>
  )
}
